import React from 'react'
import ServicePricing from './ServicePricing'

function PricePackStandardBus() {
  return (
    <>
      <div className='pricing-features'>
        <ServicePricing
          btn='Standard web design'
          panelText='A standard web layout designed to make you look more
                            professional while showcasing your business and what
                            it has to offer.'
        />
        <ServicePricing
          btn='Mobile Responsiveness'
          panelText='Your website will be optimized to look and perform well
                            on all devices. Devices include but are not limited to
                            Smart Phones, Tablets, Laptops, Televisions etc.'
        />
        <ServicePricing
          btn='10 web pages'
          panelText='This package comes with 10 web pages. Additional pages
                            come with small a fee.'
        />
        <ServicePricing
          btn='Social Media Integration'
          panelText='Your users will be able to access your various social
                            media accounts from your website.'
        />
        <ServicePricing
          btn='Social Sharing Integration'
          panelText='Turn your users into engaged customers by allowing
                            them to share your website to social media platforms
                            with one click.'
        />
        <ServicePricing
          btn='Google Maps Integration'
          panelText='We collaborate with Google to include an interactive
                            map with your business location on your website.'
        />
        <ServicePricing
          btn='Contact System Integration'
          panelText='Turn users into customers by including a contact
                            system which allow them to get in touch from your
                            website.'
        />
      </div>
    </>
  )
}

export default PricePackStandardBus
